/* eslint-disable import/order */
import { businessCapacityWorkEntryPoint } from '@jira/spa-apps__business-capacity-work/src/businessCapacityWorkEntryPoint.entrypoint.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { jiraBusinessCapacityWorkEmbedRoute } from '@jira/router-routes__business-capacity-routes/src/jiraBusinessCapacityWorkEmbedRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const capacityWorkEmbedPageEntrypoint = createChromelessEntryPoint({
	main: businessCapacityWorkEntryPoint,
});

export const jiraBusinessCapacityWorkEmbedRouteEntry: Route = createEntry(
	jiraBusinessCapacityWorkEmbedRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.jwm-capacity-work-embed',

		entryPoint() {
			if (__SERVER__) {
				return undefined;
			}
			return capacityWorkEmbedPageEntrypoint;
		},

		layout: chromelessLayout,
		skeleton: ThemedLazySkeleton,
		resources: [...jiraSpaResources(), ...getProjectViewResources()],
		supportsProjectTheme: 'contoured',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
